import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FeatherIconDirective } from 'app/back-office/shared/directives/feather-icon/feather-icon.directive';

// Solo standalone + imports: il layout orizzontale non è usato dal back-office,
// la conversione serve al template di CoreMenuComponent (standalone)
@Component({
    selector: '[core-menu-horizontal-item]',
    imports: [CommonModule, RouterModule, TranslateModule, FeatherIconDirective],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './item.component.html'
})
export class CoreMenuHorizontalItemComponent {
  @Input()
  item: any;
}
